/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PaddlePaymentRedirectParser = 
/* #__PURE__ */ parsers.object([['url', codecString]]);
export class PaddlePaymentRedirect extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PaddlePaymentRedirectParser.decode(input).map(res => new PaddlePaymentRedirect(res));
    }
    static unsafeDecode(input) {
        return PaddlePaymentRedirect.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PaddlePaymentRedirectParser.encode(data);
    }
    static schema() {
        return PaddlePaymentRedirectParser.schema();
    }
}
